import styled, { css } from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';

import { colors } from 'global/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0;
`;

export const Link = styled(RouterLink)`
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;
  color: ${colors.white};

  :hover {
    color: ${colors.green};
    text-decoration: none;
  }
`;

export const ContentContainer = styled.div`
  margin-top: 0.5rem;
  display: flex;

  @media (max-width: 576px) {
    flex-direction: column;
  }
  ${(props) =>
    props.center &&
    css`
      justify-content: center;
    `}
`;

export const ChallengeDescription = styled.p`
  color: ${colors.darkGray};
  white-space: pre-wrap;
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-all;
  & img {
    max-width: 100%;
  }
`;

export const RankingExplanationText = styled.span`
  color: ${colors.gray2};
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 10px;
`;

export const ChallengeLabel = styled.span`
  text-transform: uppercase;
  color: ${colors.gray2};
  font-weight: 300;
  font-size: 18px;
  margin-bottom: 10px;

  ${({ noMargin }) =>
    noMargin &&
    css`
      margin: 0;
    `}

  ${({ alignRight }) =>
    alignRight &&
    css`
      align-self: flex-end;
    `}

  ${({ noWrap }) =>
    noWrap &&
    css`
      white-space: nowrap;
    `}

    ${({ smallDevice }) =>
    smallDevice &&
    css`
      @media (max-width: 576px) {
        align-self: flex-start;
      }
    `}
`;

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  align-items: flex-start;

  ${(props) =>
    props.width &&
    css`
      width: ${props.width};

      @media (max-width: 576px) {
        width: 100%;
      }
    `}

  ${({ center }) =>
    center &&
    css`
      flex-direction: row;
      justify-content: center;
    `}

  ${(props) =>
    props.right &&
    css`
      flex: 0 0 auto;
      margin-left: 20px;

      @media (max-width: 576px) {
        margin-left: 0;
      }
    `}
`;

export const SectionColumn = styled.div`
  display: flex;
  flex-direction: column;
  ${({ noGap }) =>
    !noGap &&
    css`
      gap: 1rem;
    `}
`;

export const MetaInfoRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 1rem;
  width: 100%;
  margin-bottom: 20px;
`;

export const RatingAlignRow = styled.div`
  width: 100%;
  display: block;
  justify-content: end;

  @media (max-width: 576px) {
    justify-content: start;
  }
`;

export const TopListContainer = styled.div`
  background: ${colors.white};
  border-radius: 5px;
  width: 100%;
  display: flex;
  overflow: scroll;
  flex-direction: column;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  max-height: 400px;
`;

export const TopListAvatar = styled.div`
  background: url(${(props) => props.image});
  background-position: center center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 50%;
  width: ${(props) => props.size || '42'}px;
  height: ${(props) => props.size || '42'}px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ${(props) => props.size / 2 || '18'}px;
  color: ${colors.white};
  font-weight: bold;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  user-select: none;
`;

export const TopListTable = styled.table`
  overflow-y: scroll;
`;

export const TopListTableRow = styled.tr`
  background: #efefef;
  border-bottom: 1px solid ${colors.white};

  :last-child {
    border-bottom: none;
  }

  ${(props) =>
    props.alternateRow &&
    css`
      background: #dedede;
    `}

  ${(props) =>
    props.isSelf &&
    css`
      background: #c7dded;
    `}
`;

export const TopListTableHead = styled.thead``;

export const TopListTableBody = styled.tbody``;

export const TopListTableHeader = styled.th`
  text-align: left;
  color: #888;
  font-weight: 300;
  padding: 5px 0;
  margin-right: 10px;
  position: sticky;
  top: 0;
  z-index: 2;
  background: ${colors.white};
  user-select: none;

  :first-child {
    padding-left: 10px;
    width: 60px;
  }

  ${(props) =>
    props.width &&
    css`
      width: ${props.width}px;
    `}

  ${(props) =>
    props.center &&
    css`
      text-align: center;
    `}
`;

export const TopListTableCell = styled.td`
  text-align: left;
  height: 55px;
  padding: 0;
  margin-right: 10px;

  :first-child {
    padding-left: 7px;
  }

  :last-child {
    > div {
      padding: 0;
    }
  }
`;

export const TopListLabel = styled.span`
  font-size: 18px;
  color: #555;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${(props) =>
    props.isSelf &&
    css`
      font-weight: bold;
    `}
`;

export const RankListContainer = styled.div`
  width: 100%;
`;

export const AuthorAvatar = styled.div`
  border-radius: 50%;
  width: 35px;
  height: 35px;
  background-image: url(${(props) => props.image || ''});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
`;

export const AuthorContainer = styled.div`
  display: flex;
  color: ${colors.darkGray};
  align-items: center;
  font-size: 14px;
`;

export const AuthorName = styled.a`
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 1px;
  text-decoration: none;
  padding-left: 10px;
  color: ${colors.darkGray};

  :hover {
    text-decoration: none;
    color: ${colors.darkGray};
  }
`;

export const SponsorLogo = styled.div`
  position: relative;
  width: calc(100% - 1rem);
  height: 100%;
  min-height: 2rem;
  max-height: 5rem;
  background-image: url(${(props) => props.image || ''});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`;

export const ShareButtonContainer = styled.div`
  margin-top: 10px;
  text-align: right;
  @media (max-width: 576px) {
    text-align: left;
  }
`;
